<template>
    <b-modal v-model="modalShow" ref="modal-edit-parcel" size="lg" title="Editar Parcela">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="due_at" class="bmd-label-floating">Data</label>
                        <date-picker v-model="form.due_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                    </div>
                </div>
                
                <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="due_at" class="bmd-label-floating">Valor da parcela</label>
                        <money v-model="form.price" class="form-control text-right" v-bind="percent" @focus.native="$event.target.select()" placeholder="0,00"></money>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="type_of_payments" class="bmd-label-floating">Atualizar dados em todas as parcelas subsequentes?</label>
                        <b-form-checkbox
                            v-model="form.changeAllInstallments"
                            :value="true"
                            :unchecked-value="false"
                          >
                            {{ form.changeAllInstallments ? 'Sim' : 'Não' }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitEditParcel" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    import Vue from 'vue';
    import ValidationService from '@/services/validations.service';

    export default {
        data() {
            return {
                 percent: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                form: {
                    id: 0,
                    installment_id: 0,
                    price : 0,
                    due_at: new Date(),
                    changeAllInstallments: false
                },
                modalShow: true
            };
        },
        mounted() {
            var self = this;
            var installments = self.$store.state.proposals.item.installments;

            self.form.id = self.$route.params.id;
            self.form.installment_id = self.$route.params.installment;
            
            var installmentIndex = installments.findIndex(installment => installment.id == self.form.installment_id);
            var installment = installments[installmentIndex];
            
            self.form.due_at = installment.due_at;
            self.form.price  = installment.price;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        },
        methods: {
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitEditParcel(_ev) {
                _ev.preventDefault();
                var self = this;

                var proposalPayment = {
                    id: this.form.id,
                    installment_id: this.form.installment_id,
                    due_at: Vue.moment(this.form.due_at).format('YYYY-MM-DD'),
                    change_all_installments: this.form.changeAllInstallments ? '1' : '0',
                    price : this.form.price
                };
                
                self.$root.$emit("onLoading");
                const response = self.$store.dispatch('proposals/edit_parcel', proposalPayment);

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.success("Dados atualizados com sucesso!");
                    self.goBack();
                });

                response.catch(function (err) {
                    self.$root.$emit("onLoading");
                    self.$notify.error("Não foi possivel alterar o vencimento da parcela, tente novamente!");
                });
            }
        }
    };
</script>
<style scoped>
.custom-control {
    padding-left: 0;
}
</style>